import React from 'react'
import { Button, Container, Select, TextBody } from '@pmi/pmi-iqos-ds-react'
import { htmlTranslation, cookie, TierStatus } from '@pmi/pmi-iqos-shared-react'
import { buildProfileInfoData } from '@iqosphere-common/utils'
import PointsTable from './points-table'

const ProfilePointsHistory = ({
  translations,
  historyData,
  showLoadMore,
  onLoadMoreClickHandler,
  onFilterChangeHandler,
  historyType,
  historyFilters,
  isLoading
}) => {
  const warningStatusValues = {
    BRING_BACK: 7,
    EXPIRED: 99
  }
  const invertedLayoutHistoryType = 'prizes'
  const loyaltyCookieContent = cookie.getLoyaltyProfile()
  const p = loyaltyCookieContent && loyaltyCookieContent.p
  const profileInfoData = buildProfileInfoData(p)
  const tier = profileInfoData && profileInfoData.tierName

  const isWarningStatus = (status, amount) => {
    return (
      Object.values(warningStatusValues).filter(
        warningStatus => Number(status) === warningStatus
      ).length > 0 || amount < 0
    )
  }

  const dropdownOnSelect = e => {
    onFilterChangeHandler(e.target.value)
  }

  const getName = history => {
    return (
      history &&
      history.actionName +
        (history.bonusQoinsEarned && history.bonusQoinsEarned > 0
          ? (tier === TierStatus.GOLD
              ? ' (' + translations.tk_preBonusMessageGold
              : tier === TierStatus.PLATINIUM
              ? ' (' + translations.tk_preBonusMessagePlatinum
              : '') +
            '	 ' +
            history.bonusQoinsEarned +
            '	 ' +
            (tier === TierStatus.GOLD || tier === TierStatus.PLATINIUM
              ? translations.tk_afterBonusMessage + ')'
              : '')
          : '')
    )
  }

  const getHistoryValue = (history, statusView) => {
    if (statusView) {
      const translation = htmlTranslation(
        translations,
        'tk_status' + history.status
      )
      return translation && translation.value
    } else {
      return history.qoinsEarned
    }
  }

  const statusView = historyType === invertedLayoutHistoryType
  const showStageCoins =
    historyType === historyFilters[0].id || historyType === historyFilters[1].id

  return (
    <Container py="8" px={['8', '8', '6']}>
      <Container
        display={Container.displays.flex}
        justifyContent={Container.justifyContentValues.center}>
        <Container width={['7/8', '1/2', '1/4']}>
          <Select
            name="selectFilter"
            label=""
            value={historyType}
            items={historyFilters}
            getItemLabel={index => historyFilters[index].label}
            getItemValue={index => historyFilters[index].id}
            onChangeHandler={dropdownOnSelect}
            data-testing="ProfilePoints_Select_HistoryType"
          />
        </Container>
      </Container>
      {historyData && historyData.length > 0 ? (
        <Container pt="8">
          <PointsTable
            qoinsDataList={historyData}
            getDate={history => history.actionDate}
            getName={getName}
            getIsWarning={history =>
              isWarningStatus(history.status, history.qoinsEarned)
            }
            getValueLabel={history =>
              statusView
                ? translations.tk_statusLabel
                : showStageCoins && history.type === 1
                ? translations.tk_tab2StatusStage
                : translations.tk_tab2Status
            }
            getValue={history => getHistoryValue(history, statusView)}
            invertedValueLayout={statusView}
          />
          {showLoadMore ? (
            <Container
              pt="8"
              display={Container.displays.flex}
              justifyContent={Container.justifyContentValues.center}>
              <Button
                disabled={isLoading}
                onClickHandler={onLoadMoreClickHandler}
                variant={Button.variants.secondary}
                text={translations.tk_loadMore}
                data-testing="ProfilePoints_Button_HistoryLoadMore"
              />
            </Container>
          ) : null}
        </Container>
      ) : (
        <Container pt="8">
          <TextBody
            alignment={TextBody.alignments.center}
            {...htmlTranslation(translations, 'tk_noRecords')}
            data-testing="ProfilePoints_TextBody_HistoryNoRecords"
          />
        </Container>
      )}
    </Container>
  )
}

export default ProfilePointsHistory
